import type { FC } from 'react';
import React, { Fragment } from 'react';
import { Subscribe } from 'unstated';

import { DismissibleBanner } from '@confluence/banners/entry-points/DismissibleBanner.tsx';
import { BannerStateContainer } from '@confluence/banners/entry-points/BannerStateContainer.ts';
import type { BannerStateInfo } from '@confluence/banners/entry-points/BannerStateContainer.ts';

const DEV_TOOLS_BANNER_NAME = 'DEV_TOOLS_BANNER';

type bannerComponentProps = {
	name: string;
	height: number;
	bannerState: BannerStateContainer;
};

const BannerComponent: FC<bannerComponentProps> = ({ name, bannerState, height }) => {
	return (
		<DismissibleBanner
			height={height}
			onDismiss={() => {
				bannerState.hide(name);
			}}
		>
			Banner
		</DismissibleBanner>
	);
};

export const DevToolsBanner = () => {
	return (
		<Subscribe to={[BannerStateContainer]}>
			{(bannerState: BannerStateContainer) => {
				return (
					<Fragment>
						{bannerState.state.banners.map((banner: BannerStateInfo) => {
							return banner.name.includes(DEV_TOOLS_BANNER_NAME) ? (
								<BannerComponent
									bannerState={bannerState}
									name={DEV_TOOLS_BANNER_NAME}
									height={banner.height}
								/>
							) : null;
						})}
					</Fragment>
				);
			}}
		</Subscribe>
	);
};
